module.exports = __webpack_public_path__ + "img/platform-A.da853de4.jpg";